export default "__VITE_ASSET__BvCbL_Uw__"